export const getAuthToken = () => {
  /* eslint-disable-next-line no-undef */
  if (sessionStorage.getItem('session_token')){
    /* eslint-disable-next-line no-undef */
    return sessionStorage.getItem('session_token');
  }
  if (localStorage.getItem('session_token')){
    return localStorage.getItem('session_token');
  }
  return '';
};

export const getCookieValue = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
};
/* These are deprecated. Do not use for new development. These require a user id so they are limited
   in terms of what these functions can be used for. */
export const saveStorage = (key, userId, data) => {
  try {
    localStorage.setItem(key, JSON.stringify({ userId, data }));
    return true;
  } catch (e) {
    return false;
  }
};

export const removeStorage = (key) => {
  try {
    localStorage.removeItem(key);
    return true;
  } catch (e) {
    return false;
  }
};

export const getStorage = (key, userId) => {
  try {
    const cookie = localStorage.getItem(key);
    const parsed = JSON.parse(cookie);
    const { userId: exId, data } = parsed;
    if ( exId === userId) return data;
    return {};
  } catch (e) {
    return null;
  }
};
/* end deprecation */

export const setCookie = (name, value, days) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
};

export const getCookie = (name) => {
  const cookieArr = document.cookie.split(';');
  for (let i = 0; i < cookieArr.length; i += 1) {
      const cookiePair = cookieArr[i].split('=');
      if (name === cookiePair[0].trim()) {
          return decodeURIComponent(cookiePair[1]);
      }
  }
  return null;
};

export const deleteCookie = (name) => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
};

